import Divider from '@/components/common/Divider';
import useLanguage from '@/utils/hooks/useLanguage';
import Modal, { ModalHeader, ModalProps, ModalTitle } from '../Modal';
import CryptoDepositForm from './CryptoDepositForm';
import FiatDepositForm from './FiatDepositForm';

export interface PortalDepositModalProps extends ModalProps {
    mode: 'bank' | 'crypto';
    currency?: string;
    onRefresh?: () => void;
}

const PortalDepositModal = (props: PortalDepositModalProps) => {
    const { handlers, mode } = props;

    const lang = useLanguage();

    return (
        <Modal {...props} className="h-auto" size="max-w-lg">
            <ModalHeader>
                <ModalTitle>
                    {mode === 'bank' ? lang.portal.depositViaBankTransfer : lang.portal.depositViaCryptoTransfer}
                </ModalTitle>
                {/* <ModalClose handlers={handlers} /> */}
            </ModalHeader>
            <Divider neutral />
            {mode === 'bank' ? <FiatDepositForm {...props} /> : <CryptoDepositForm {...props} />}
        </Modal>
    );
};

export default PortalDepositModal;
